import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseReturnActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Return/ReturnBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseSalesReturn"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseSalesReturn"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseReturnActivity)
